(function () {
  const OPEN_CLASS = 'sk-select--open';

  const preserveQueryAndHashOnLangLinks = () => {
    const search = window.location.search;
    const hash = window.location.hash;
    if (!search && !hash) return;
    document.querySelectorAll('a[hreflang]').forEach((link) => {
      const href = link.getAttribute('href');
      if (!href) return;
      if (href.includes('?') || href.includes('#')) return;
      link.setAttribute('href', href + search + hash);
    });
  };

  const init = (root) => {
    const toggle = root.querySelector('[data-sk-lang-toggle]');
    const dropdown = root.querySelector('[data-sk-lang-dropdown]');
    if (!toggle || !dropdown) return;

    const open = () => {
      root.classList.add(OPEN_CLASS);
      toggle.setAttribute('aria-expanded', 'true');
      document.dispatchEvent(new CustomEvent('sk:menu-opened', {detail: {source: root}}));
    };
    const close = () => {
      root.classList.remove(OPEN_CLASS);
      toggle.setAttribute('aria-expanded', 'false');
    };
    const isOpen = () => root.classList.contains(OPEN_CLASS);

    toggle.addEventListener('click', (event) => {
      event.stopPropagation();
      if (isOpen()) {
        close();
      } else {
        open();
      }
    });

    document.addEventListener('click', (event) => {
      if (isOpen() && !root.contains(event.target)) close();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isOpen()) {
        close();
        toggle.focus();
      }
    });

    document.addEventListener('sk:menu-opened', (event) => {
      if (!isOpen()) return;
      if (event.detail && event.detail.source === root) return;
      close();
    });
  };

  const boot = () => {
    preserveQueryAndHashOnLangLinks();
    document.querySelectorAll('[data-sk-lang-switcher]').forEach(init);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
